/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterDSmall = createReactComponent("outline", "letter-d-small", "IconLetterDSmall", [["path", { "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", "key": "svg-0" }]]);

export { IconLetterDSmall as default };
//# sourceMappingURL=IconLetterDSmall.mjs.map
